import { render } from "./MemberWrapper.vue?vue&type=template&id=00c7541e&scoped=true"
import script from "./MemberWrapper.vue?vue&type=script&lang=js"
export * from "./MemberWrapper.vue?vue&type=script&lang=js"

import "./MemberWrapper.vue?vue&type=style&index=0&id=00c7541e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c7541e"]])

export default __exports__